define([
    './defined',
    './defaultValue',
    './jsonObjectParser'
], function (
    defined,
    defaultValue,
    jsonObjectParser
) {
    'use strict'

    /**
     * 将json内容反序列化成数组对象。
     *
     * @private
     *
     * @exports json2Array
     */
    const json2Array = (str) => {
        let result = jsonObjectParser.parse(str)
        return result
    };
    return json2Array
});
